<template>
  <div class="lostItems">
    <h1>{{ $t("lostItems.title") }}</h1>
    <div class="email-section">
      <div v-if="userRole === 'Investigation' || userRole === 'SuperAdmin'" class="email-input">
        <label class="bolded">{{ $t("lostItems.alertEmail") }}</label>
        <input type="text" v-model="emails" :placeholder="$t('lostItems.alertEmailPlaceholder')" />
        <p v-if="error" class="error">Este campo no puede estar vacío</p>
      </div>
      <div v-if="userRole === 'Security'" class="email-input">
        <label class="bolded">{{ $t("lostItems.alertEmail") }}</label>
        <input
          type="text"
          v-model="securityEmails"
          :placeholder="$t('lostItems.alertEmailPlaceholder')"
        />
        <p v-if="error" class="error">Este campo no puede estar vacío</p>
      </div>
      <button class="btn btn-update" @click="validateForm(userRole)">{{ $t("lostItems.btnUpdate") }}</button>
      <button class="btn btn-register" @click="openRegisterModal" v-if="tableToShow === 'collected'">{{ $t("lostItems.btnRegister") }}</button>
    </div>
    <div class="switchs">
      <SwitchButtons
        v-if="userRole === 'Investigation' || userRole === 'SuperAdmin'"
        name="lostItems"
        :values="types"
        @tipo="setTable"
      />
      <SwitchButtons
        v-if="userRole === 'Security'"
        name="lostItems"
        :values="typesSecurity"
        @tipo="setTable"
      />
      <CollectionRequest v-if="tableToShow === 'waiting_collection'"></CollectionRequest>
      <Collected v-if="tableToShow === 'collected'" ref="CollectedRef"></Collected>
      <Inventoried v-if="tableToShow === 'inventoried'"></Inventoried>
      <Historical v-if="tableToShow === 'historical'"></Historical>
    </div>
    <Modal v-if="showRegisterModal" @closeModal="closeRegisterModal" >
    <template #header>
      <h4>{{ $t("lostItems.lostItemRegister.title") }}</h4>
    </template>

    <template >
      <div class="bg-white p-3 row item-details">
        <div class="col-md-12">

          <div v-if="errorMessage" class="alert alert-danger mb-3">
            {{ errorMessage }}
          </div>

          <label class="bolded" for="folio">{{ $t("lostItems.lostItemDetail.folio") }}</label>
          <input type="text" id="folio" class="mb-3" v-model="folio" required />

          <label class="bolded">{{ $t("lostItems.lostItemDetail.description") }}</label>
          <input type="text" v-model="itemInfo" required />

          <!-- Fecha y hora -->
          <label class="mt-4 bolded">{{ $t("lostItems.lostItemDetail.dateHour") }}</label>
          <div class="d-flex gap-2">
            <input type="date" v-model="dateCollection" class="form-control" required />
            <input type="time" v-model="timeCollection" class="form-control" required />
          </div>

          <label class="bolded">{{ $t("lostItems.lostItemDetail.collector") }}</label>
          <input type="text" v-model="collectorCollection" required />

          <label class="mt-4 bolded">{{ $t("lostItems.lostItemDetail.placeCollection") }}</label>
          <input type="text" v-model="placeCollection" required />

          <label class="mt-4 bolded">{{ $t("lostItems.lostItemDetail.category") }}</label>
          <select v-model="categorySelected">
            <option disabled value>
              {{ $t("lostItems.lostItemDetail.categoryPlaceholder") }}
            </option>
            <option
              v-for="(category, index) in categories"
              :key="index"
            :value="category.id"
            >
            {{ category.name }}
          </option>
        </select>

      </div>
    </div>
    </template >

    
    <template #footer>
      <button class="btn btn-cancel" @click="closeRegisterModal">Cancelar</button>
      <button class="btn btn-save" @click="createItem" > Guardar</button >
    </template >
  </Modal >
  </div >

</template >

<script>
const SwitchButtons = () => import("@/components/Switch");
const CollectionRequest = () => import("../lostItems/CollectionRequestTable.vue");
const Collected = () => import("../lostItems/CollectedTable.vue");
const Inventoried = () => import("../lostItems/InventoriedTable.vue");
const Historical = () => import("../lostItems/HistoricalTable.vue");
const Modal = () => import("@/components/Modal");
import API_SERVICE from "@/lib/api/lostItems.js";
const api = new API_SERVICE();

export default {
  components: {
    CollectionRequest,
    SwitchButtons,
    Collected,
    Inventoried,
    Historical,
    Modal
  },
  data() {
    return {
      tableToShow: "collected",
      emails: "",
      securityEmails: "",
      showRegisterModal: false,
      folio: "",
      itemInfo: "",
      dateCollection: "",
      timeCollection: "",
      placeCollection: "",
      collectorCollection: "",
      errorMessage: "",
      categories: [],
      categorySelected: 0,
      error: false,
    };
  },
  async beforeMount() {
    await this.getCategory();
    if (this.userRole === "Security") {
      await this.getEmailSec();
    } else {
      await this.getEmail();
    }
  },
  methods: {
    setTable: function (types) {
      this.tableToShow = types;
    },
    getEmail: async function () {
      this.$store.commit("global/SET_LOADING", true);
      try {
        const resp = await api.getEmail();
        this.emails = resp.title;
        this.$store.commit("global/SET_LOADING", false);
      } catch (error) {
        this.$store.commit("global/SET_LOADING", false);
        throw error;
      }
    },
    getEmailSec: async function () {
      this.$store.commit("global/SET_LOADING", true);
      try {
        const resp = await api.getEmailSecurity();
        this.securityEmails = resp.title;
        this.$store.commit("global/SET_LOADING", false);
      } catch (error) {
        this.$store.commit("global/SET_LOADING", false);
        throw error;
      }
    },
    validateForm: async function (role) {
      if (role === "Security") {
        if (this.securityEmails === "") {
          this.error = true;
        } else {
          this.updateEmailSecurity();
          this.error = false;
        }
      } else if (role === "Investigation") {
        if (this.emails === "") {
          this.error = true;
        } else {
          this.updateEmail();
          this.error = false;
        }
      }
    },
    updateEmail: async function () {
      this.$store.commit("global/SET_LOADING", true);
      try {
        const resp = await api.saveEmail(this.emails);
        this.$store.commit("global/SET_LOADING", false);
      } catch (error) {
        this.$store.commit("global/SET_LOADING", false);
        throw error;
      }
    },
    updateEmailSecurity: async function () {
      this.$store.commit("global/SET_LOADING", true);
      try {
        const resp = await api.saveEmailSecurity(this.securityEmails);

        this.$store.commit("global/SET_LOADING", false);
      } catch (error) {
        this.$store.commit("global/SET_LOADING", false);
        throw error;
      }
    },
    openRegisterModal() {
      this.errorMessage = '';
      this.showRegisterModal = true;
    },
    closeRegisterModal() {
      this.showRegisterModal = false;
    },
    async createItem() {
      this.$store.commit("global/SET_LOADING", true);
      try {
        this.errorMessage = "";
        if (!this.folio || !this.itemInfo || !this.dateCollection || !this.timeCollection || !this.collectorCollection ||
          !this.placeCollection) {
          this.errorMessage = "Por favor, completa todos los campos.";
          return;
        }

        const autor = this.$store.getters["session/author"];
        // 🕓 Waiting Collection
        const params = {
          status: 'collected',
          folio: this.folio,
          collector: this.collectorCollection,
          itemInfo: this.itemInfo,
          dateCollection: this.dateCollection,
          timeCollection: this.timeCollection,
          placeCollection: this.placeCollection,
          categoryId: this.categorySelected,
          email: this.emails,
          userName: autor
        };

        const result = await api.createItem(params);
        
        console.log("Respuesta API:", result);
        this.closeRegisterModal();
        this.resetForm();

        if (this.$refs.CollectedRef) {
          this.$refs.CollectedRef.getItems();
        }

      } catch (error) {
        console.error(error);
      } finally {
        this.$store.commit("global/SET_LOADING", false);
      }
    },
    async getCategory() {
      const currentLanguage = localStorage.getItem("lang");
      this.$store.commit("global/SET_LOADING", true);

      try {
        const resp = await api.getLostItemsCategorys(currentLanguage);
        this.categories = resp.categories; // <-- NOTA: debe existir en data()
      } catch (error) {
        console.error(error);
      } finally {
        this.$store.commit("global/SET_LOADING", false);
      }
    },
    resetForm() {
      this.folio = "";
      this.itemInfo = "";
      this.dateCollection = "";
      this.timeCollection = "";
      this.placeCollection = "";
      this.collectorCollection = "";
      this.categorySelected = 0;
      this.errorMessage = "";
    },
  },
  computed: {
    types: function () {
      return [
        {
          label: this.$t("lostItems.tabs.Collected.tabTitle"),
          value: "collected",
        },
        {
          label: this.$t("lostItems.tabs.Inventoried.tabTitle"),
          value: "inventoried",
        },
        {
          label: this.$t("lostItems.tabs.Historical.tabTitle"),
          value: "historical",
        },
      ];
    },
    typesSecurity: function () {
      return [
        {
          label: this.$t("lostItems.tabs.collectionRequests.tabTitle"),
          value: "waiting_collection",
        },
        {
          label: this.$t("lostItems.tabs.Collected.tabTitle"),
          value: "collected",
        },
      ];
    },
    userRole() {
      return this.$store.getters["session/role"];
    },
  },
};
</script>

<style>
.lostItems .email-section {
  width: 60%;
  display: flex;
  align-items: center;
  margin-top: 2rem;
}

.lostItems .email-section .email-input label {
  font-weight: bold;
  font-size: 1rem;
}

.lostItems .email-section .btn-update {
  border: 1px solid #000;
  border-radius: 0px;
  padding: 0.7rem 1.5rem;
  margin-left: 4rem;
}

.lostItems .email-section .btn-update:hover {
  background-color: #000;
  color: #fff;
}

.lostItems .switchs {
  margin-top: 2rem;
  margin-left: -1rem;
}

.error {
  color: #bb0a30;
}

.screenshotss {
  min-width: 100%;
  width: 100% !important;
}

.lostItems .email-section .btn-register {
  border: 1px solid #000 !important;
  background-color: #000 !important;
  color: #fff !important;
  padding: 0.7rem 1.5rem !important;
  margin-left: 3rem !important;
  border-radius: 0px !important;
  width: 300px !important;
}

.lostItems .email-section .btn-register:hover {
  background-color: #000 !important;
  border: 1px solid #FFF !important;
  color: #fff !important;
}

.btn-save {
  border: 1px solid #000 !important;
  background-color: #000 !important;
  color: #fff !important;
  padding: 0.7rem 1.5rem !important;
}

.btn-save:hover {
  background-color: #000 !important;
  border: 1px solid #FFF !important;
}

.modal-header .close {
  display: none !important;
}
</style>
